import React from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes/routes";
import MaltoraLogo from "../landing/MaltoraLogo";

const SignupConfirmationContent: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        fontFamily: "var(--font-ui, DM Sans, system-ui, sans-serif)",
      }}
    >
      {/* LEFT */}
      <div
        style={{
          width: "380px",
          flexShrink: 0,
          background: "linear-gradient(160deg,#0F2D2B 0%,#1F5F5B 100%)",
          display: "flex",
          flexDirection: "column",
          padding: "44px 40px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-60px",
            right: "-60px",
            width: "250px",
            height: "250px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.04)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-80px",
            left: "-40px",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.03)",
            pointerEvents: "none",
          }}
        />
        <a
          href="/"
          style={{
            display: "block",
            width: "100px",
            marginBottom: "44px",
            flexShrink: 0,
          }}
        >
          <MaltoraLogo fill="#fff" />
        </a>
        <span
          style={{
            display: "block",
            fontSize: "10.5px",
            fontWeight: "700",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "#E86A0D",
            marginBottom: "12px",
          }}
        >
          Start for free
        </span>
        <h2
          style={{
            fontFamily:
              "var(--font-display, Satoshi, DM Sans, system-ui, sans-serif)",
            fontSize: "22px",
            fontWeight: "700",
            color: "#fff",
            lineHeight: "1.3",
            letterSpacing: "-0.02em",
            marginBottom: "12px",
          }}
        >
          Run your brewery.
          <br />
          <em
            style={{
              fontStyle: "italic",
              color: "rgba(255,255,255,0.6)",
              fontWeight: "700",
            }}
          >
            Finally, like a system.
          </em>
        </h2>
        <p
          style={{
            fontSize: "13.5px",
            color: "rgba(255,255,255,0.55)",
            lineHeight: "1.6",
            marginBottom: "28px",
          }}
        >
          One platform for orders, inventory, payments, and every stakeholder in
          your supply chain.
        </p>
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            margin: "0 0 32px",
            display: "flex",
            flexDirection: "column",
            gap: "11px",
          }}
        >
          {[
            "Digital ordering for buyers and sellers",
            "Live inventory across all warehouses",
            "Payment tracking and credit management",
            "Sales rep dashboards and performance visibility",
          ].map((f) => (
            <li
              key={f}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                fontSize: "13.5px",
                color: "rgba(255,255,255,0.8)",
                lineHeight: "1.45",
              }}
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="rgba(147,197,253,0.9)"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ flexShrink: 0, marginTop: "2px" }}
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {f}
            </li>
          ))}
        </ul>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginTop: "auto",
          }}
        >
          <div style={{ display: "flex" }}>
            {["#1F5F5B", "#5F8F3A", "#E86A0D", "#0B4740"].map((c, i) => (
              <div
                key={i}
                style={{
                  width: "26px",
                  height: "26px",
                  borderRadius: "50%",
                  background: c,
                  border: "2px solid rgba(255,255,255,0.2)",
                  marginLeft: i ? "-8px" : 0,
                }}
              />
            ))}
          </div>
          <span style={{ fontSize: "12.5px", color: "rgba(255,255,255,0.65)" }}>
            500+ outlets managed
          </span>
        </div>
      </div>

      {/* RIGHT - Confirmation Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fff",
          padding: "16px 24px 48px",
          overflowY: "auto",
        }}
      >
        <div style={{ width: "100%", maxWidth: "480px", textAlign: "center" }}>
          {/* Success Icon */}
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "rgba(31, 95, 91, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 32px",
            }}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#1F5F5B"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>

          {/* Title */}
          <h1
            style={{
              fontFamily:
                "var(--font-display, Satoshi, DM Sans, system-ui, sans-serif)",
              fontSize: "32px",
              fontWeight: "700",
              color: "#0F172A",
              marginBottom: "16px",
              letterSpacing: "-0.02em",
            }}
          >
            Welcome aboard!
          </h1>

          {/* Message */}
          <p
            style={{
              fontSize: "16px",
              color: "#64748B",
              lineHeight: "1.6",
              marginBottom: "32px",
            }}
          >
            Your account has been created successfully. We&apos;ve sent your
            login details to your registered email ID.
          </p>

          {/* Check your inbox section */}
          <div
            style={{
              background: "#F8F9FA",
              borderRadius: "12px",
              padding: "24px",
              marginBottom: "32px",
              textAlign: "left",
            }}
          >
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#0F172A",
                marginBottom: "12px",
                margin: "0 0 12px 0",
              }}
            >
              Check your inbox
            </h3>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                fontSize: "14px",
                color: "#64748B",
                lineHeight: "1.6",
              }}
            >
              <li style={{ marginBottom: "8px", display: "flex", gap: "8px" }}>
                <span style={{ color: "#1F5F5B" }}>•</span>
                Look for an email from Maltora
              </li>
              <li style={{ marginBottom: "8px", display: "flex", gap: "8px" }}>
                <span style={{ color: "#1F5F5B" }}>•</span>
                Check your spam/junk folder if you don&apos;t see it
              </li>
            </ul>
          </div>

          {/* Sign in button */}
          <button
            onClick={() => navigate(`/${routes.public.signIn}`)}
            style={{
              width: "100%",
              height: "48px",
              background: "#E86A0D",
              color: "#fff",
              fontFamily: "var(--font-ui, DM Sans, system-ui, sans-serif)",
              fontSize: "15px",
              fontWeight: "700",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              letterSpacing: "0.01em",
              transition: "background 0.15s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#d45e0b";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#E86A0D";
            }}
          >
            Sign in to your account
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupConfirmationContent;
